import axios from "@/plugins/axios"
import { mapActions } from "vuex"

var form = {
  data() {
    return {
      relations: [],
      params: {}
    }
  },
  mounted() {
    this.doMounted()
  },
  methods: {
    ...mapActions(['queue']),
    load(id) {
      return this.api.get(id).then((response) => {
        this.form = response.data
      })
    },
    loadWithTrashed(id, isArchive) {
      return this.api.get({id, archive: isArchive}).then((response) => {
        this.form = response.data
      })
    },
    save() {
      let promise = this.api.save(this.form).then(() => {
        this.errors = []
        this.success()
      }, response => {
        this.errors = response.errors
      })

      this.queue(promise)
    },
    doMounted() {
      if (this.$route.params.id > 0) {
        Promise.all(this.relations).then(() => {
          this.queue(this.load(this.$route.params.id))
        });
      }
      else {
        this.afterLoad()
      }
    },
    loadRelation(method) {
      let promise = method()

      this.queue(promise)
      this.relations.push(promise)
    },

    afterLoad() {

    },
    removeEmptyFields(source) { // temporary unused
      let data = Object.assign({}, source)
      for (var key in data) {
        if (data[key] === null || data[key] === undefined || data[key] === '') {
          delete data[key];
        }
      }
      return data
    },

    success() {
      this.$router.go(-1)
    }
  }
}

export default form;
